import { SettingsIntegrationBase } from '@app/models/company/settings/integrations/integration-base.model';

export class IntegrationJazzhr extends SettingsIntegrationBase {
    protected static _type = 'jazzhrs';

    protected static _resource = 'companyManagement/companies/:company/integrations/jazzhr';

    protected static _serializeAttributes = ['apiKey'];

    get apiKey(): string {
        return this._attributes['apiKey'];
    }
    set apiKey(val: string) {
        this._attributes['apiKey'] = val;
    }
}
